import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=1c2bbe64&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2bbe64')) {
      api.createRecord('1c2bbe64', component.options)
    } else {
      api.reload('1c2bbe64', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=1c2bbe64&", function () {
      api.rerender('1c2bbe64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8YQZm2NC2f3Pu/JS/videoIframe.vue"
export default component.exports